import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../actions/auth";
import { DASHBOARD_ROUTE, FORMS_ROUTE,CANDIDATE_FORM_ROUTES,FORM_SUBMIT_ROUTE } from "../routes";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Container from "@mui/material/Container";
import HeightBox from "../components/HeightBox";
import TextInputField from "../components/TextInputField";
import { useHistory } from "react-router-dom";
import BackgroundImage from "../images/login.png";
import ImageLeft from "../images/login-left.svg";
import { Alert } from "@mui/material";
import { JOB_ORDERS_PAGE } from "../layout/data";

const ContainerStyled = styled(Paper)(({ theme }) => ({
  background: "rgb(0,8,36)",
  background:
    "linear-gradient(146deg, rgba(0,8,36,1) 0%, rgba(16,156,241,1) 14%, rgba(0,212,255,0.48641454872964807) 100%)",
  ...theme.typography.body2,
  paddingLeft: theme.spacing(10),
  paddingRight: theme.spacing(10),
  paddingTop: theme.spacing(5),
  textAlign: "left",
  color: theme.palette.text.secondary,
  borderRadius: 65,
  border: "#fff solid 1px",
}));

const CustomButton = styled(Button)(({ theme }) => ({
  width: 430,
  height: 64,
}));

const validationSchema = Yup.object().shape({
  userName: Yup.string().required().label("Username"),
  password: Yup.string()
    .required()
    .min(8)
    .max(15)
    .label("Password")
    .matches(/\d+/, "Password should contain at least one number")
    .matches(/[a-z]+/, "Password should contain at least one lowercase character")
    .matches(/[A-Z]+/, "Passoword should contain at least one uppercase character")
    .matches(/[!@#$%^&*()-+]+/, "Password should contain at least one special character"),
});

const Login = () => {
  let history = useHistory();
  const { user, error, loadingLogin } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  // Connect the backend and login the user
  function logInTheUser(values) {
    dispatch(login(values));
  }
  useEffect(() => {

   // Assuming you have imported 'history' and 'DASHBOARD_ROUTE', 'JOB_ORDERS_PAGE', 'CANDIDATE_FORM_ROUTES', and 'CANDIDATE_PORTAL_ROUTE' constants.

// Define the delay time in milliseconds (2 seconds in this case)
const delayTime = 2000;

// Assuming 'user' contains the user object with the 'token' and 'role' properties.

if (user?.token) {
  // Add a 2-second delay before executing the redirection logic
  setTimeout(() => {
    if (user?.role === 1) {
      history.push(DASHBOARD_ROUTE);
    } else if (user?.role === 4) {
      history.push('client-home');
    } else if (user?.role === 5) {
      history.push('candidate-portal'); // Replace 'candidate-portal' with the actual route constant if available.
    } else {
      history.push(CANDIDATE_FORM_ROUTES);
    }
  }, delayTime);
}

    // if(user?.token && user.role===5){
    //   window.location.reload()
    //   history.push('candidate-portal')
    // }
  }, [user]);
  return (
    <Container
      maxWidth={false}
      style={{
        width: "100vw",
        overflowY: "hidden",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        border: "solid .01px",
      }}
    >
      <HeightBox height={16} />
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={10}>
        <Grid item>
          <img src={ImageLeft} alt="" alignItems="left" width={450} />
        </Grid>
        <Grid item paddingTop={10}>
          <ContainerStyled elevation={0} paddingTop={10}>
            <Formik
              initialValues={{
                userName: "",
                password: "",
              }}
              onSubmit={(values) => {
                logInTheUser(values);
              }}
              // validationSchema={validationSchema}
            >
              {(formikProps) => {
                const { errors, handleSubmit, handleChange, touched } = formikProps;

                return (
                  <Form>
                    <Typography variant="h4" gutterBottom component="div" fontWeight={700} color="white">
                      Recruitsplus Portal Login
                    </Typography>
                    <Typography variant="body2" gutterBottom component="div" fontWeight={700} color="white">
                      Please enter the username and password for your account.<br></br>
                      If you don't have an account, please contact the administrator. <br></br> 
                      Client Portal : info@recruitsplus.org <br></br>
                      Candidate Portal : cv@recruitsplus.org
                    </Typography>
                    <HeightBox height={20} />
                    {error && <Alert severity="error">{error}</Alert>}
                    <HeightBox height={10} />
                    <TextInputField
                      label="Username"
                      width={430}
                      height={44}
                      onChange={handleChange("userName")}
                      errorMessage={touched.userName ? errors.userName : ""}
                    />
                    <HeightBox height={25} />
                    <TextInputField
                      label="Password"
                      password
                      width={430}
                      height={44}
                      onChange={handleChange("password")}
                      errorMessage={touched.password ? errors.password : ""}
                    />
                    <HeightBox height={25} />
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Remember me"
                      style={{
                        color: "white",
                      }}
                    />
                    <HeightBox height={25} />
                    <CustomButton variant="contained" color="primary" onClick={handleSubmit}>
                      Log in
                    </CustomButton>
                  </Form>
                );
              }}
            </Formik>
            <HeightBox height={100} />
          </ContainerStyled>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Login;
